<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <!-- <div class="d-sm-flex align-items-center">
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div> -->
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <tbody>
              <tr>
                <th class="w-50">
                    #
                </th>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ demandes[0]?.id }}
                </td>
                <th>
                    Decodeur
                </th>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ demandes[0]?.decodeur?.numAbonnement }}
                </td>
              </tr>
              <tr>
                <th>
                    Abonné
                </th>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ demandes[0]?.utilisateur?.nom }}
                </td>
                <th>
                    Contact
                </th>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ demandes[0]?.utilisateur?.telephone }}
                </td>
              </tr>
              <tr>
                <th>
                    Montant Payer
                </th>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ demandes[0]?.montantPayer }} F CFA
                </td>
                <th>
                    Montant Remise
                </th>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ demandes[0]?.montantRemise }} F CFA
                </td>
              </tr>
            </tbody>
            <br>
            <div>
                <div class="d-sm-flex align-items-center">
                    <a
                        class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#AddElementModal"
                        @click="modification(demandes[0])"
                    >
                       Valider la demande
                    </a>
                    <a href="javascript:void(0);" class="default-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0 text-decoration-none"
                     @click="suppression(demandes[0].id,demandes,'demande','cette demande')">
                        Annuler la demande
                    </a>
                </div>
            </div>
          </table>
        </div>
      </div>
    </div>

    <ValiderDemande :item="selectedItem"   @close="recharger"/>
  </template>
  
  <script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { paginationFields } from '../Utilities/paginationFields';
import { error, suppression, format_DATE } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import  { Demande }  from '../../models/Demande';
import ValiderDemande from './ValiderDemandeModal.vue';
import { formatDate } from '@fullcalendar/core';

  export default defineComponent({
    name: "DetailDemande",
    components: {
      ValiderDemande
    },
    setup: () => {

      const route = useRoute();
      const demandes = ref<Array<Demande>>([]);
      const selectedItem = ref(0);
     
      function modification(item) {
        // magasin.value = item;
        selectedItem.value = item.id;
      }



      onMounted( async () => {
        let id = route.params.id;
        if (Array.isArray(id)) {
            id = id[0];
        }
        await getOne(id);
      })

      function getOne(id='') {
        return ApiService.get(`demande/${id}`)
        .then(({ data }) => {
          console.log('result', data.data);
          demandes.value = [data.data];
          console.log("yes",demandes.value);
        })
        .catch(({ response }) => {
          console.log('error',response.data)
          error(response.data)
        });
      } 

      return { 
        suppression,
        modification,
        demandes,
        selectedItem,
        format_DATE,
      };
    }

  });
  </script>